export const DOT = '•';
export const ASTERISK = '*';

export const PROFILE_TYPES = {
  BASIC: 'BASIC',
  BASIC_V2: 'BASIC_V2',
  PRO_V2: 'PRO_V2',
  PRO: 'PRO',
  SMART: 'SMART',
  PREMIUM: 'PREMIUM',
};

export const DATE_FORMAT = {
  LETTERS: 'letters',
  LETTERS_FULL: 'lettersFull',
  NUMBERS: 'numbers',
  NEED_ZERO_STRING_BEFORE: 10,
  AM: 'AM',
  PM: 'PM',
  SELECT_AM_OR_PM: 12,
};

export const AMOUNT_LATEST_TRANSACTIONS = 8;

export const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export const KEY_CODES = {
  ENTER: 'Enter',
};

export const NUMBERS = {
  THOUSAND: 1000,
  MIL: 1000000,
  MIL_LENGTH: 7,
};

export const CURRENCY = {
  USD: { SYMBOL: '$', title: 'USD' },
  NIS: { SYMBOL: '₪', title: 'NIS' },
};

export const CURRENCY_USD_SIGN = '$';

export const DOCS_AREA_NO_DATA_MESSAGE = {
  CURRENT_YEAR_NO_STATEMENTS: 'Your statements will be displayed once your account has transactions in it',
  CURRENT_YEAR_NO_REPORTS: 'Your reports will be displayed once your account has transactions in it',
  NOT_CURRENT_YEAR_NO_STATEMENTS: 'There are no statements for selected period',
  NOT_CURRENT_YEAR_NO_REPORTS: 'There are no reports for the selected period',
};

export const USER_ACCOUNT_TYPE = {
  PRO: 'PRO',
  BASIC: 'BASIC',
};

export const NO_API_KEY = 'NoApiKey';

export const ENVS = {
  INTEG_DOMAIN: 'integ-app.lili.co',
  LOCAL_DEV: 'app.lili.co:3',
};

export const FORMAT_TYPE = {
  FORMATTED: 'formatted',
  UNFORMATTED: 'unformatted',
};

export const BIG_SCREEN_WIDTH = 1440;
export const MIN_SCREEN_LENGTH = 1180;
export const TABLET_SCREEN_WIDTH = 768;

export const SESSION_POPUP_TIMES = {
  OPEN_POPUP: 1000 * 60 * 10,
  COUNTER_TIME: 1000,
  COUNTER: 30,
};

export const LATEST_TRANSACTIONS_TEXT = {
  LATEST_TRANSACTIONS: 'LATEST_TRANSACTIONS_HEADER',
  SHOW_ALL: 'LATEST_TRANSACTIONS_SHOW_ALL',
  NO_TRANSACTIONS: 'LATEST_TRANSACTIONS_NO_TRANSACTIONS',
};

export const COUNTRIES = {
  US: 'US',
};

export const TRANSACTIONS_HEADER = 'TRANSACTIONS_PAGE_HEADER';
export const EMERGENCY_BUCKET_TRANSACTIONS_HEADERS = {
  BASIC: 'EMERGENCY_BUCKET_TRANSACTIONS_PAGE_HEADER_BASIC',
  PRO: 'EMERGENCY_BUCKET_TRANSACTIONS_PAGE_HEADER_PRO',
} as const;

export const LOADER_PROCESSING_TEXT = 'BUTTON_LOADER_TEXT';

export const EXPENSE_REPORTS_PAGE_HEADER = 'EXPENSE_REPORTS_PAGE_HEADER';
export const STATEMENTS_PAGE_HEADER = 'STATEMENTS_PAGE_HEADER';

export const APY = '3.00';

export const TERMS_CONDITIONS_LINK = 'https://lili.co/terms-conditions';
export const LEGAL_DOC_TERMS_OF_USE = 'https://lili.co/legal-documents/lili-terms-of-use';
export const LEGAL_DOC_TERMS_AND_CONDITIONS_CHOICE = 'https://lili.co/legal-documents/choice-account-agreement';
export const LEGAL_DOC_TERMS_AND_CONDITIONS_SUNRISE = 'https://lili.co/legal-documents/sunrise-account-agreement';
export const LEGAL_DOC_PRIVACY_POLICY = 'https://lili.co/legal-documents/lili-privacy-policy';

export const LEGAL_DOC_VISA_T_AND_C_SUNRISE = 'https://lili.co/legal-documents/sunrise-visa-savingsedge-terms';
export const LEGAL_DOC_VISA_T_AND_C_CHOICE = 'https://lili.co/legal-documents/choice-visa-savingsedge-terms';
export const MAX_LENGTH_LETTERS_CATEGORIZE_CARD = 12;

export const INPUT_WITH_CURRENCY = {
  INITIAL_MARGIN: 127,
  SYMBOL_STEP: 6.3,
};

export const MAX_VALUE_BY_CUSTOMER = 999999999;

export const TOOLTIP_MAX_LETTRES = 25;
export const TOOLTIP_NEED_MORE_SPACE = 35;

export const CARD_ACTION = {
  CARD_STATUS: {
    UNKNOWN: undefined,
    CANCELED_WITHOUT_REFUND: 'Z',
    STOLEN: 'S',
    DELINQUENT: 'Q',
    LOST: 'L',
    VOIDED: 'V',
    CHARGED_OFF: 'R',
    WAITING_FOR_PAYMENT: 'W',
    CANCELED: 'C',
    CARD_REISSUE_NEEDS_FUND: 'A',
    SET_TO_EMBOSS: 'X',
    SHIPPED_AND_READY_ACTIVATE: 'Y',
    BLOCKED: 'B',
    OPERATION_HOLD: 'O',
    DISABLED: 'D',
    ACTIVE: 'N',
  },
  PRETTY_STATUS: {
    UNKNOWN: 0,
    RETURN_TO_SENDER: 1,
    NEEDS_FUND: 2,
    CARD_ON_PRINT: 3,
    ACTIVATION_REQUIRED: 4,
    ACTIVE: 5,
  },
  CANCEL_REASON: {
    LOST: 'lost',
    STOLEN: 'stolen',
  },
  SHIPPING_STATUS: {
    SHIPPED: 'shipped',
    RETURNED_TO_SENDER: 'returnedToSender',
  },
};

export const DAY_IN_MILLISECONDS = 24 * 60 * 60 * 1000;

export const REDIRECT_CHECK_OPTIONS = {};

export const MIN_YEAR_TO_ACTIVATE_CARD = Number(new Date().getFullYear().toString().slice(2));

export const FEATURE_FLAG = {
  SEGMENTED_INCOME_CHART: 'Segmented Income Chart',
  CHARTS: 'Charts',
  INCOME_CHART: 'Income Chart',
  ADD_NEW_BUSINESS: 'Add New Business',
  SET_PIN: 'set-pin',
  ACH_OUT_TRANSFER: 'Ach Out Transfer',
  ADA_BETA: 'ADA Beta Users',
  BALANCE_UP: 'BalanceUp',
  PRO_REGISTRATION: 'Pro Registration',
  INVOICE: 'Invoice',
  EXPENSE_REPORTS: 'Expense Reports',
  VSE: 'Show VSE Offer',
  TAX_BUCKET: 'Tax Bucket',
  EMERGENCY_BUCKET: 'Emergency Bucket',
  EMERGENCY_SAVING_ACCOUNT: 'Emergency Savings Account',
  PAYEES_MIGRATION_REPORT: 'Payees Migration Report',
  SCHEDULE_C: 'Schedule C',
  CATEGORIZATION: {
    FEATURE: 'Categorization',
    INCOME: 'Income Categorization',
    SPLIT: 'Split Categorization Edit',
  },
  CREATE_INVOICE: 'Create Invoice',
  PLAN_UPGRADE: 'Lili Plans Upgrade',
  PLAN_UPGRADE_TERMS_AND_CONDITIONS: 'Plans Upgrade T&C',
  CATEGORIZE_AI: 'Categorization AI',
  MAIL_CHECK: 'Mail a Check',
  DOMESTIC_WIRE_OUT: 'Wire Transfer Out',
  INTERNATIONAL_WIRE_OUT: 'International Wire Out Transfer',
  CASH_FLOW: 'Cash Flow Reports',
  PROFIT_AND_LOSS: 'Profits and Loss Reports',
  BILL_PAY: 'Bill Pay',
  NEW_ACH_OUT: 'New ACH Out',
  ScheduleK: 'Form 1065',
  Form1120s: 'Form 1120s',
  Form1120: 'Form 1120 C-Corp',
  CPA: 'Talk to CPA',
  Gusto: 'Gusto',
  TRANSACTIONS_FACELIFT: 'transaction-facelift',
  ACCOUNTANT_AI: 'Accountant AI',
  EXPORT_TRANSACTION: 'Export Transactions',
  ASSET_CATALOG: 'AssetCatalog',
  INVITE_ACCOUNTANT: 'Invite Accountant',
  ASK_VENDOR_FOR_DETAILS: 'Ask Vendor For Details',
  NOTIFY_VENDOR: 'Notify Vendor',
  SYNC_CARD: 'Sync Credit Card',
  INTERNATIONAL_WIRE_IN_TRANSFER: 'International Wire In Transfer',
  EXPENSE_REPORT_V2: 'Expense Report V2',
  INVITE_ADMIN: 'InviteAdmin',
};

export const AUTOMATION_TEST_ID = 'webapp';

export const HELP_CENTER_LINK = 'https://support.lili.co/hc';

export const ENTER_KEY = 'Enter';
